import { render, staticRenderFns } from "./phoneStrip.vue?vue&type=template&id=5bce062e&"
import script from "./phoneStrip.vue?vue&type=script&lang=js&"
export * from "./phoneStrip.vue?vue&type=script&lang=js&"
import style0 from "./phoneStrip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports